import * as React from "react";
import JSONTree from 'react-json-tree';
import ObjectPath from "object-path";
import flat from "flat";
import { v4 as uuidv4 } from 'uuid';
import Highlighter from "react-highlight-words";

import '../styles/Button.css';
import '../styles/JsonTree.css'

import iconLoop from '../../assets/icons/loop.svg'

import WordInsertions from "../utils/WordInsertions";
import Config from "../Config";
import MetamodelStore from "../resources/data/MetamodelStore";
import FilterSearch from "./filters/FilterSearch";
import ModalRelationData from "./modals/ModalRelationData";
import JsonTreeCommons from "../utils/JsonTreeCommons";

import StateGlobal from "../StateGlobal";

export default class AttrTree extends React.Component
{
    constructor(props)
    {
        super(props);

        this.aFilterSearchRef = React.createRef();
        this.aModalRel = React.createRef();

        this.state = {
            sTreeKey: uuidv4(),
            allObjects: [],
            allModels: []
        };

        Config.getConfig();
    }

    aTreeTheme = {
        base00: '#FFFFFF',
        base01: '#000000',
        base02: '#000000',
        base03: '#000000',
        base04: '#000000',
        base05: '#000000',
        base06: '#000000',
        base07: '#000000',
        base08: '#000000',
        base09: '#000000',
        base0A: '#000000',
        base0B: '#000000',
        base0C: '#000000',
        base0D: '#000000',
        base0E: '#000000',
        base0F: '#000000'
    };

    refreshSearch = () =>
    {
        this.state.sTreeKey = uuidv4();
        this.setState({});
    }

    render()
    {
        const aTreeData = JSON.parse(JSON.stringify(this.props.treeData)); // data from props doesn't change. This const is modified by JSONTree component.
        const bIsNested = this.props.isNested;
        const sDirection = this.props.direction;
        const bIsInnerLoop = this.props.isInnerLoop;
        const sRelationName = this.props.relationName;
        const bIsTarget = this.props.isTarget ? this.props.isTarget : false;
        const bPreventRelationNotebook = this.props.preventRelationNotebook;
        const typeOfRel = this.props.typeOfRel;
        const isSingleLvl = this.props.isSingleLvl

        var aTreeValsToSearch = aTreeData ? flat.flatten(aTreeData) : null;
        if (aTreeValsToSearch)
        {
            aTreeValsToSearch = Object.keys(aTreeValsToSearch);
        }
        var sSearchInput = this.aFilterSearchRef.current ? this.aFilterSearchRef.current.getSearchInput() : null;
        var aSearchLabels = {};
        switch (this.props.dataType)
        {
            case "models":
                aSearchLabels = Config.strings.jsonTree.search.mainModelNotebook;
                break;
            case "objects":
                aSearchLabels = Config.strings.jsonTree.search.mainObjectNotebook;
                break;
            case "relation":
                aSearchLabels = Config.strings.jsonTree.search.relationNotebook;
                break;
        }

        return (
            <div>
                {aTreeData &&
                    <div>
                        <FilterSearch
                            aValsToSearch={aTreeValsToSearch}
                            aExclusions={["id_group", "chapter_name", "sName", "sType"]}
                            resultsReadyCallback={this.refreshSearch}
                            ref={this.aFilterSearchRef}
                            sSearchPlaceholderTxt={aSearchLabels.searchPlaceholder}
                            sSearchIndicatorTxt={aSearchLabels.searchingIndicator}
                            sSearchNoResultsTxt={aSearchLabels.searchNoResults}
                        />
                        <JSONTree
                            key={this.state.sTreeKey}
                            data={aTreeData}
                            hideRoot={true}
                            theme={{
                                extend: this.aTreeTheme,
                                arrowSign: {
                                    fontFamily: "Segoe UI Symbol, sansSerif",
                                    color: "#AFAFAF"
                                },
                                tree: {
                                    fontSize: "12px"
                                }
                            }}
                            invertTheme={false}
                            shouldExpandNode={(keyPath) =>
                            {
                                if (this.aFilterSearchRef.current)
                                {
                                    keyPath.reverse();
                                    var sKeyPathFlat = keyPath.join('.');
                                    keyPath.reverse();

                                    var bCheck = this.aFilterSearchRef.current.checkSearch(sKeyPathFlat);
                                    return bCheck;
                                }
                                return false;
                            }}
                            postprocessValue={(value) =>
                            {
                                // remove specific items from json (useed only for configuration)

                                if (Object.hasOwnProperty.call(value, 'sType'))
                                {
                                    delete value['sType'];
                                }
                                if (Object.hasOwnProperty.call(value, 'id_group'))
                                {
                                    delete value['id_group'];
                                }
                                if (Object.hasOwnProperty.call(value, 'chapter_name'))
                                {
                                    delete value['chapter_name'];
                                }
                                if (Object.hasOwnProperty.call(value, 'sName'))
                                {
                                    const sName = value.sName;
                                    value = sName;
                                }
                                return value;
                            }}
                            labelRenderer={(keyPath) =>
                            {
                                // get icons
                                keyPath.reverse();
                                const aInitData = ObjectPath.get(this.props.treeData, keyPath);
                                keyPath.reverse();

                                if (aInitData && Object.hasOwnProperty.call(aInitData, 'id_group'))
                                {
                                    try
                                    {
                                        var sIcon = MetamodelStore.getInstance().getIcon(aInitData.id_group);


                                    } catch (err)
                                    {
                                        console.warn(err);
                                    }
                                }

                                var bHasButton = aInitData && Object.hasOwnProperty.call(aInitData, 'chapter_name');

                                return (
                                    <div
                                        className={bHasButton ? "JsonTree__buttonLabel" : ""}
                                        onClick={event => event.preventDefault()}
                                    >
                                        {sIcon &&
                                            <img src={"data:image/png;base64," + sIcon} />
                                        }
                                        {' '}
                                        <label className={bHasButton ? "JsonTree__buttonLabelText" : ""}>
                                            <Highlighter
                                                highlightStyle={{ background: "#FFFF00" }}
                                                textToHighlight={keyPath[0]}
                                                searchWords={[sSearchInput]}
                                                autoEscape={true}
                                            />

                                        </label>
                                        {bHasButton &&
                                            <button className="wrcButton wrcButton--small" onClick={(event) =>
                                            {
                                                event.stopPropagation();
                                                WordInsertions.insertText(keyPath[0], "After")
                                            }
                                            }>
                                                {Config.strings.jsonTree.buttons.insertChapterName}
                                            </button>
                                        }
                                    </div>
                                );
                            }}
                            valueRenderer={(sStringValue, aValue, ...keyPath) =>
                            {
                                const sRelNameFromPath = keyPath[0];
                                keyPath.reverse();
                                const aKeyPathReversed = JSON.parse(JSON.stringify(keyPath));
                                keyPath.reverse();
                                const initValue = ObjectPath.get(this.props.treeData, aKeyPathReversed);

                                if (initValue.hasOwnProperty("direction"))
                                {
                                    
                                    return (
                                        <div>
                                            <button className="wrcButton wrcButton--medium wrcButton--medium--object" onClick={() =>
                                            {
                                                const aModalData = JsonTreeCommons.getDataForRelationModal({
                                                    data: initValue,
                                                });

                                                // StateGlobal._currentBradCrumbs.push(sRelNameFromPath)
                                                StateGlobal._currentRelDirection = initValue.direction
                                                
                                                this.aModalRel.current.setTargetClasssesNotebooks(aModalData.targetNotebooks.classes);
                                                this.aModalRel.current.setTargetModeltypesNotebooks(aModalData.targetNotebooks.modeltypes);
                                                this.aModalRel.current.setNotebook(aModalData.relNotebook);
                                                this.aModalRel.current.setDirection(initValue.direction);
                                                this.aModalRel.current.setRelationName(initValue.sName);
                                                if(StateGlobal._currentBradCrumbs.length === 0){
                                                    this.aModalRel.current.setTypeRel("all");
                                                }else{
                                                    this.aModalRel.current.setTypeRel("");
                                                }
                                                this.aModalRel.current.toggleModal();
                                            }
                                            }>
                                                {Config.strings.jsonTree.buttons.insertRelData}
                                            </button>
                                        </div>
                                    );
                                } else
                                {
                                    if (bIsNested)
                                    {

                                        return (
                                            <div className="flex flex-row">
                                                {typeOfRel === "all" ? 
                                                <>
                                                <button className="wrcButton wrcButton--small" onClick={
                                                    WordInsertions.relationData.bind(this, {
                                                        sName: aValue,
                                                        sType: initValue.sType,
                                                        sData: 'name',
                                                        direction: sDirection,
                                                        isTarget: bIsTarget,
                                                        isInnerLoop: bIsInnerLoop,
                                                        relName: sRelationName,
                                                        oldUI: true
                                                    })
                                                }>
                                                    {Config.strings.jsonTree.buttons.insertPropertyLabel}
                                                </button>

                                                <button className="wrcButton wrcButton--small" onClick={
                                                    WordInsertions.relationData.bind(this, {
                                                        sName: aValue,
                                                        sType: initValue.sType,
                                                        sData: 'value',
                                                        direction: sDirection,
                                                        isTarget: bIsTarget,
                                                        isInnerLoop: bIsInnerLoop,
                                                        relName: sRelationName,
                                                        oldUI: true,
                                                        ctrlType: initValue.ctrlType
                                                    })
                                                }>
                                                    {Config.strings.jsonTree.buttons.insertPropertyValue}
                                                </button>
                                                </>
                                                :
                                                <>
                                                <button className="wrcButton wrcButton--small" onClick={
                                                    WordInsertions.propertyData.bind(this, {
                                                        sName: aValue,
                                                        sType: initValue.sType,
                                                        sData: 'name'
                                                    })
                                                }>
                                                    {Config.strings.jsonTree.buttons.insertPropertyLabel}
                                                </button>

                                                <button className="wrcButton wrcButton--small" onClick={
                                                    WordInsertions.propertyData.bind(this, {
                                                        sName: aValue,
                                                        sType: initValue.sType,
                                                        sData: 'value',
                                                        direction: initValue.sType === "REL" && (initValue.isIncomingRel ? "INCOMING" : "OUTGOING"),
                                                        ctrlType: initValue.ctrlType,
                                                        listMode:   initValue.sType === "REL" ? true : false
                                                    })
                                                }>
                                                    {Config.strings.jsonTree.buttons.insertPropertyValue}
                                                </button>
                                                </>}
                                                

                                                {initValue.sType === "REL" && <button className="wrcButton wrcButton--icon" onClick={() =>
                                                {

                                                    const updatedInitValue = {
                                                        ...initValue,
                                                        direction: initValue.isIncomingRel ? "INCOMING" : "OUTGOING"
                                                    }

                                                    StateGlobal._currentRelDirection = initValue.sType === "REL" && (initValue.isIncomingRel ? "INCOMING" : "OUTGOING")


                                                    const aModalData = JsonTreeCommons.getDataForRelationModal({
                                                        data: updatedInitValue,
                                                    });

                                                    const relationNameLang = Config.getLangName(Object.values(MetamodelStore.getInstance().getRelations()).find(aRel =>
                                                        {
                                                            return aRel.sName === updatedInitValue.sName;
                                                        }));
    
                                                        
                                                    StateGlobal._currentBradCrumbs.push(sRelNameFromPath);
                                                    
                                                    this.aModalRel.current.setTargetClasssesNotebooks(aModalData.targetNotebooks.classes);
                                                    this.aModalRel.current.setTargetModeltypesNotebooks(aModalData.targetNotebooks.modeltypes);
                                                    this.aModalRel.current.setNotebook(aModalData.relNotebook);
                                                    this.aModalRel.current.setDirection(updatedInitValue.direction);
                                                    this.aModalRel.current.setRelationName(updatedInitValue.sName);
                                                    if(StateGlobal._currentBradCrumbs.length === 0){
                                                        this.aModalRel.current.setTypeRel("all");
                                                    }else{
                                                        this.aModalRel.current.setTypeRel("");
                                                    }
                                                    this.aModalRel.current.toggleModal();

                                                    aModalData.modelID.forEach((el) => {
                                                        var aMetaModelTypeData = MetamodelStore.getInstance().getMetaModelType(el);
                                                        this.state.allModels.push(aMetaModelTypeData.aDisplayName[Config.lang.selected])
                                                        aMetaModelTypeData.classes.forEach((classes) => {
                                                            const exists = this.state.allObjects.some(obj => obj === classes);
                                                            if (!exists) {
                                                                this.state.allObjects.push(classes);
                                                            }
                                                        });
                                                    });

                                                }
                                                }>
                                                    {/* UI 3.0 */}
                                                    {StateGlobal._currentBradCrumbs.length > 0 && <div className="wrcButton--relation">
                                                    <img src={iconLoop} height={15}/>
                                                    </div>}
                                                </button>}

                                            </div>
                                        );
                                    } else {
                                        return (
                                            <div className="flex flex-row">
                                                <button className="wrcButton wrcButton--small" onClick={
                                                    WordInsertions.propertyData.bind(this, {
                                                        sName: aValue,
                                                        sType: initValue.sType,
                                                        sData: 'name'
                                                    })
                                                }>
                                                    {Config.strings.jsonTree.buttons.insertPropertyLabel}
                                                </button>

                                                <button className="wrcButton wrcButton--small" onClick={
                                                    WordInsertions.propertyData.bind(this, {
                                                        sName: aValue,
                                                        sType: initValue.sType,
                                                        sData: 'value',
                                                        direction: initValue.sType === "REL" && (initValue.isIncomingRel ? "INCOMING" : "OUTGOING"),
                                                        ctrlType: initValue.ctrlType,
                                                        listMode:   initValue.sType === "REL" ? true : false
                                                    })
                                                }>
                                                    {Config.strings.jsonTree.buttons.insertPropertyValue}
                                                </button>
                                                
                                                {initValue.sType === "REL" && 
                                                <>
                                                
                                                <button className="wrcButton wrcButton--icon" onClick={() =>
                                                {

                                                const updatedInitValue = {
                                                    ...initValue,
                                                    direction: initValue.sType === "REL" && (initValue.isIncomingRel ? "INCOMING" : "OUTGOING")
                                                }

                                                StateGlobal._currentRelDirection = initValue.sType === "REL" && (initValue.isIncomingRel ? "INCOMING" : "OUTGOING")


                                                const aModalData = JsonTreeCommons.getDataForRelationModal({
                                                    data: updatedInitValue,
                                                });

                                                const relationNameLang = Config.getLangName(Object.values(MetamodelStore.getInstance().getRelations()).find(aRel =>
                                                    {
                                                        return aRel.sName === updatedInitValue.sName;
                                                    }));

                                                const notebookRelName = aKeyPathReversed.reverse()[0]
                                                    
                                                StateGlobal._currentBradCrumbs.push(sRelNameFromPath);

                                                this.aModalRel.current.setTargetClasssesNotebooks(aModalData.targetNotebooks.classes);
                                                this.aModalRel.current.setTargetModeltypesNotebooks(aModalData.targetNotebooks.modeltypes);
                                                this.aModalRel.current.setNotebook(aModalData.relNotebook);
                                                this.aModalRel.current.setDirection(updatedInitValue.direction);
                                                this.aModalRel.current.setRelationName(updatedInitValue.sName);
                                                this.aModalRel.current.toggleModal();
                                                
                                                aModalData.modelID.forEach((el) => {
                                                    var aMetaModelTypeData = MetamodelStore.getInstance().getMetaModelType(el);
                                                    this.state.allModels.push(aMetaModelTypeData.aDisplayName[Config.lang.selected])
                                                    aMetaModelTypeData.classes.forEach((classes) => {
                                                        const exists = this.state.allObjects.some(obj => obj === classes);
                                                        if (!exists) {
                                                            this.state.allObjects.push(classes);
                                                        }
                                                    });
                                                });

                                                }
                                            }>
                                                {/* UI 3.0 */}
                                                <div className="wrcButton--relation">
                                                    <img src={iconLoop} height={15}/>
                                                </div>
                                            </button>
                                            </>
                                            }

                                            </div>
                                        );
                                    }
                                }
                            }}
                            getItemString={() => { return null }}
                        />
                        <ModalRelationData
                            ref={this.aModalRel}
                            titleNotebook={Config.strings.modals.relationData.sTitleNotebook}
                            titleClasses={Config.strings.modals.relationData.sTitleClasses}
                            titleModeltypes={Config.strings.modals.relationData.sTitleModeltypes}
                            innerLoop={bIsInnerLoop}
                            preventRelationNotebook={bPreventRelationNotebook}
                            hideLoop={typeOfRel === "all"}
                            allObjects={this.state.allObjects}
                            allModels={this.state.allModels}
                        />
                    </div>
                }
            </div>
        );
    }
}
